import { useChatbotScreen } from "../hooks/useChatbotScreen";
import { ChatbotScreenBase } from "../components/ChatbotScreenBase";

function Unified() {
    const props = useChatbotScreen("unified");
    return <ChatbotScreenBase {...props} />;
}

export default Unified;
